var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "$";
Shopify.formatMoney = function (cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.', ''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
};
 
function saveDrawerSavePrice(){
     let totalPrice = 0;
     let finalComTotal = 0;
     let totalQty = 0;
     let varPriceTotal = 0;
     let itemoriginalPrice = 0;
     let itemSubTotal = 0;
     let finalOriginalTotal = 0;
     let savingPrice = 0;
     let SavingPercentage = 0;
     let cartTotal = parseInt($('.js_subtotal').attr('data-cart-total'));
     let subTotal = 0;
     $( ".jl-side-cart__product-box" ).each(function( index ) {
       let comPrice = parseInt($(this).attr('data-com-price'));
       let originalPrice = parseInt($(this).attr('data-price'));
       let qty = $(this).find('.js_cart_drawer_qty option:selected').val();
       totalQty = parseInt(qty);
       totalPrice = parseInt(comPrice);
       itemoriginalPrice = parseInt(originalPrice);
       itemSubTotal =  parseInt(itemoriginalPrice * totalQty)
       varPriceTotal = parseInt(totalPrice * totalQty);
       finalComTotal += parseInt(varPriceTotal);
       finalOriginalTotal += parseInt(itemSubTotal);
       savingPrice = parseInt(finalComTotal - finalOriginalTotal);
       //cartTotal = parseInt(cartTotal + savingPrice);
       SavingPercentage = (parseInt(savingPrice)/parseInt(finalComTotal)*100).toFixed(2);
       subTotal = parseInt(cartTotal + savingPrice);

       // console.log( "Saving Price " + finalComTotal);
       // console.log( "Compare At Price " + varPriceTotal);
      });
      
      if(savingPrice != ''){
         $('#savings-amount').html('-' + Shopify.formatMoney(savingPrice, $('body').attr('data-money-format')));
         $('.savings-amount-wrap').show();
      }else{
         $('.savings-amount-wrap').hide();
      }
      
      $('.js_subtotal').html(Shopify.formatMoney(subTotal, $('body').attr('data-money-format')));
      // $('#savings-percentage').text(SavingPercentage + '% OFF');
}

function saveCartSavePrice(){
   let totalPrice = 0;
   let finalComTotal = 0;
   let totalQty = 0;
   let varPriceTotal = 0;
   let itemoriginalPrice = 0;
   let itemSubTotal = 0;
   let finalOriginalTotal = 0;
   let savingPrice = 0;
   let SavingPercentage = 0;
   let cartTotal = parseInt($('.js_cartsubtotal').attr('data-cart-total'));
   let subTotal = 0;
   $( ".jl-cart__product-add-box" ).each(function( index ) {
     let comPrice = parseInt($(this).attr('data-com-price'));
     let originalPrice = parseInt($(this).attr('data-price'));
     let qty = $(this).find('.js_qty option:selected').val();
     totalQty = parseInt(qty);
     totalPrice = parseInt(comPrice);
     itemoriginalPrice = parseInt(originalPrice);
     itemSubTotal =  parseInt(itemoriginalPrice * totalQty)
     varPriceTotal = parseInt(totalPrice * totalQty);
     finalComTotal += parseInt(varPriceTotal);
     finalOriginalTotal += parseInt(itemSubTotal);
     savingPrice = parseInt(finalComTotal - finalOriginalTotal);
     SavingPercentage = (parseInt(savingPrice)/parseInt(finalComTotal)*100).toFixed(2);
     subTotal = parseInt(cartTotal + savingPrice);
   });
    if(savingPrice != ''){
     $('.js-cart-save').html(Shopify.formatMoney(savingPrice, $('body').attr('data-money-format')));
     $('.js-cart-save-wrap').show();
   }else{
      $('.js-cart-save-wrap').hide();
   } 
    $('.js_cartsubtotal').html(Shopify.formatMoney(subTotal, $('body').attr('data-money-format')));
    // $('#savings-percentage').text(SavingPercentage + '% OFF');
}

function youMayAlsoLikeCart(){
   $('.you-may-also-like-slider-cart-page').slick({
      dots: false,
      infinite: false,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<button type="button" class="slick-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/2674/6290/files/icon-left-arrow.svg?v=1698987956" alt="Slider Arrow " loading="lazy" /></button>',
      nextArrow: '<button type="button" class="slick-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/2674/6290/files/icon-right-arrow.svg?v=1698987957" alt="Slider Arrow " loading="lazy" /></button>',
  });
}

function youMayAlsoLike() {
    $('.you-may-also-like-slider-cart').slick({
       dots: false,
       infinite: false,
       arrows: true,
       slidesToShow: 1,
       slidesToScroll: 1,
       prevArrow: '<button type="button" class="slick-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/2674/6290/files/icon-left-arrow.svg?v=1698987956" alt="Slider Arrow " loading="lazy" /></button>',
       nextArrow: '<button type="button" class="slick-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/2674/6290/files/icon-right-arrow.svg?v=1698987957" alt="Slider Arrow " loading="lazy" /></button>',
    });
 }
  function redirectToSection(sectionId) {
  var section = document.getElementById(sectionId);
  section.scrollIntoView({
      behavior: 'smooth',
      block: 'start', 
      inline: 'nearest'
  });
}
 function redirectToSection(sectionId) {
    var element = document.getElementById(sectionId);
    var headerOffset = 100;
    var elementPosition = element.getBoundingClientRect().top;
    var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
    window.scrollTo({
       top: offsetPosition,
       behavior: "smooth"
    });
 }
 
 function recomandationProductLength() {
   let recLength = $('.jl-recomandation-li').length;
   if (recLength > 0) {
      $('.jl-recomandation-li-wrapper').show();
   } else {
      $('.jl-recomandation-li-wrapper').hide();
   }
}
 
 function updateCart() {
    $.ajax({
       url: '/cart?view=jl-cart-drawer',
       dataType: 'HTML',
       method: "GET",
       success: function (htmlData) {
          let html_markup = $(htmlData);
          let to_replace = $(htmlData).find('#cw-cart').html();
          $('#cw-cart').html(to_replace);
          saveDrawerSavePrice();
          setTimeout(function() {}, 200);
            youMayAlsoLike();
       }
    });
 }
 
 $(document).ready(function () {
    $(document).on(`click`, `.jl-variants__input`, function (e) {
       e.preventDefault();
       console.log('click')
       let newURL = $('.jl-variants__input:checked').val();
       window.location = newURL;
    });
 
    $(document).on(`click`, `.jl-variants__input__recommendation`, function (e) {
       e.preventDefault();
       let newRecommendationURL = $('.jl-variants__input__recommendation:checked').val();
       window.location = newRecommendationURL;
    });
 
    $(document).on(`click`, `.jl-variants__input__recent`, function (e) {
       e.preventDefault();
       let newURL = $('.jl-variants__input__recent:checked').val();
 
       window.location = newURL;
    });
 
    $(document).on('click', '.home_atc', function (e) {
       e.preventDefault();
       let varId = $(this).attr('data-id');
       $.ajax({
          url: "/cart/add.js",
          data: {
             id: varId,
             quantity: 1
          },
          method: "POST",
          dataType: "JSON",
          success: function (data) {
             //window.location = "/cart";
             setTimeout(function () {}, 2000);
             $('.jl-side-cart').addClass('open');
             $('body').addClass('scroll-hidden');
             updateCart();
          },
          error: function (data) {
             window.alert(data.responseJSON.description);
          }
       });
    });
 
 
    $(document).on('change', `.js-cw-product-page-form [data-option-1], .js-cw-product-page-form [data-option-2],.js-cw-product-page-form [data-option-3]`, function (e) {
       let option1 = option2 = option3 = null;
 
       if ($(`.js-cw-product-page-form [data-option-1]`).length > 0) {
          option1 = $(`.js-cw-product-page-form [data-option-1] option:selected`).val();
       }
       if ($(`.js-cw-product-page-form [data-option-2]`).length > 0) {
          option2 = $(`.js-cw-product-page-form [data-option-2] option:selected`).val();
       }
       if ($(`.js-cw-product-page-form [data-option-3]`).length > 0) {
          option3 = $(`.js-cw-product-page-form [data-option-3] option:selected`).val();
       }
       let variant_id = null;
       let current_selected_option = null;
       if (option2 == null & option3 == null) {
 
          current_selected_option = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}']`);
          variant_id = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}']`).val();
       }
       if (option2 != null & option3 == null) {
 
          current_selected_option = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}']`);
          variant_id = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}']`).val();
       }
       if (option2 != null & option3 != null) {
 
          current_selected_option = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`);
          variant_id = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`).val();
       }
       if (variant_id == null) {
          $(`.js-cw-product-page-form .stock`).fadeOut(100);
          $(`.js-cw-product-page-form .js-out-stock`).fadeIn(100);
          $(`.js-cw-product-page-form .product_page_atc`).addClass('soldout');
          $(`.js-cw-product-page-form .product_page_atc span`).text("Unavailable");
          return true;
       }
       let price = $(current_selected_option).attr('data-price');
       let compare_at_price = $(current_selected_option).attr('data-compareat-price');
       let discount = $(current_selected_option).attr('data-discount');
       let image_src = $(current_selected_option).attr('data-image');
       let itemQty = $(current_selected_option).attr('data-qty');
       let afterPayPrice = $(current_selected_option).attr('data-afterpayprice')
       let save = $(current_selected_option).attr('data-save');
       let is_available = $(current_selected_option).attr('data-available');
       $('.js_afterpay').attr('data-amount', price);
       $(`.js_after_pay`).attr('data-price', afterPayPrice);
        let setAfterPayPrice = $('.js_after_pay').attr('data-price');
       
         let dividaedPrice = (setAfterPayPrice / 4).toFixed(2); 
        console.log('New Price ' + dividaedPrice)
      if(save != ''){
        $(`.js_save_price`).html('save ' + save);
        $(`.js_save_price_wrap`).show();
      }else{
        $(`.js_save_price_wrap`).hide();
      }
       
       $(`.js_after_pay`).html('$' + dividaedPrice);
       $(`.js-cw-product-page-form select.actual-variants`).val(variant_id).trigger('change');
       $(`.js-cw-product-page-form .js-compare-price`).text(compare_at_price);
       $(`.js-price`).html(price);
       $(`.js_sticky_price`).html(price);
       $(`.js_sticky_price`).html(price);
       if(compare_at_price){
       $(`.js-compare-price`).html(compare_at_price);
       $(`.js_sticky_comprice`).html(compare_at_price);
       $(`.js-compare-price`).show();
       $(`.js_sticky_comprice`).show();
      }else{
         $(`.js-compare-price`).hide();
         $(`.js_sticky_comprice`).hide();
      }
       $(`.js-cw-product-page-form .js_discount`).text('Save ' + discount + '%');
       $(`.jsproqty`).text(itemQty);
       if (is_available == 'true') {
          $(`.js-cw-product-page-form .stock`).show();
          $(`.js-cw-product-page-form .js-out-stock`).hide();
          $(`.js-cw-product-page-form .product_page_atc`).removeClass('soldout');
          $(`.js-cw-product-page-form .product_page_atc span`).text("Add to Cart Now");
          $(`.jl-productStock__wrapper`).removeClass('outstock_data');
       } else {
          $(`.js-cw-product-page-form .stock`).hide();
          $(`.js-out-stock`).show();
          $(`.jl-productStock__wrapper`).addClass('outstock_data');
          $(`.product_page_atc`).addClass('soldout');
          $(`.product_page_atc span`).text("Soldout");
       }
       // let current_position = null;
       // cw.variants.forEach((em,ix) => {
       // 	if( em.id == variant_id && em.featured_image != null ) {
       // 		current_position = em.featured_image.position - 1;
       // 		$(`.probig.slider-for`).slick('slickGoTo',current_position);
       // 	}
       // });
 
       // let currentVarImagePath = $(current_selected_option).attr('data-image');
       // let featSrc = ''; // Declare outside the loop
       // $(".js_images").each(function() {
       //     featSrc = $(this).attr('data-new-image'); // Remove let to update the existing variable
       //     if (currentVarImagePath == featSrc) {
       //         console.log('matched');
       //         $(this).trigger('click');
       //         return false;
       //     }
       // });
 
       var newurl =
          window.location.protocol +
          '//' +
          window.location.host +
          window.location.pathname +
          '?variant=' +
          variant_id;
       window.history.replaceState({
          path: newurl
       }, '', newurl);
       /*
       console.log(variant_id);
       console.log(price);
       console.log(compare_at_price);
       console.log(discount);
       console.log(image_src);
       console.log(save);
       */
    });
 
    $(document).on(`click`, `.js-cw-product-page-form .product_page_atc`, function (e) {
       e.preventDefault();
       let items = Array();
       let form_data_array = $(`.js-cw-product-page-form`).serializeArray();
       let item = {};
       form_data_array.forEach((em, ix) => {
          item[em.name] = em.value;
       });
       items.push(item);
       $(`.js-cw-product-page-form .cw-upsells:checked`).each(function (ix, em) {
          let upsell_item = {};
          upsell_item.id = $(em).val();
          upsell_item.quantity = 1;
          items.push(upsell_item);
       });
       $.ajax({
          url: "/cart/add.js",
          data: {
             items: items
          },
          method: "POST",
          dataType: "JSON",
          success: function (data) {
             $('.jl-side-cart').addClass('open');
             $('body').addClass('scroll-hidden');
 
             updateCart();
          },
          error: function (data) {
             window.alert(data.responseJSON.description);
          }
       });
    });
 
    // jQuery('.scrollTo').click(function(e) {
    //     var jump = jQuery(this).attr('href');
    //     var new_position = jQuery(jump).offset();
    //     jQuery('html, body').stop().animate({ scrollTop: new_position.top }, 800 , function(){
    //         var jump = jQuery(e.target).attr('href');
    //         var new_position = jQuery(jump).offset() - 1000;
    //         jQuery('html, body').stop().animate({ scrollTop: new_position.top }, 500);
    //     });
    //     e.preventDefault();
    // });
 
 
    $(document).ready(function () {
       jQuery('.scrollTo').click(function (e) {
          var jump = jQuery(this).attr('href');
          var header = jQuery('header').height() + 50;
          var new_position = jQuery(jump).offset().top - header;
          jQuery('html, body').stop().animate({
             scrollTop: new_position
          }, 800);
          e.preventDefault();
       });
    });
    $('.js_drop_change').trigger('change');
 });
 
 $(document).ready(function () {
    var randNum = Math.floor(Math.random() * 60) + 1;
    $('.js_qty_pro').text(randNum);
    $('.progress-done').attr('data-done', randNum);
    $('.progress-done').css('width', randNum + '%');
 
    var randNumWatching = Math.floor(Math.random() * 10) + 1;
    $('.js_random_watching').text(randNumWatching);
 });
 
 
 $(document).ready(function () {
    $(document).on('click', '.jl-btn-pagination', function (e) {
       e.preventDefault();
       let total_pages = $(this).attr('data-totalpages');
       let current_page = $(this).attr('data-currentpage');
       let next_page = parseInt(current_page);
       let ajax_url = $(this).attr('data-ajaxurl');
       $.ajax({
          url: ajax_url + "?page=" + next_page + "&view=ajax-collection",
          type: 'GET',
          success: function (htmlData) {
 
             let html_markup = $(htmlData);
             let to_replace = $(htmlData).find('.js_col_ajax_pagination').html();
             $('#js_col_ajax_pagination').html(html_markup);
          }
       });
    });
    $(document).on('click', '.jl-next-btn-pagination', function (e) {
       e.preventDefault();
       let total_pages = $(this).attr('data-totalpages');
       let current_page = $(this).attr('data-currentpage');
       let next_page = parseInt(current_page) + 1;
       let ajax_url = $(this).attr('data-ajaxurl');
       $.ajax({
          url: ajax_url + "?page=" + next_page + "&view=ajax-collection",
          type: 'GET',
          success: function (htmlData) {
 
             let html_markup = $(htmlData);
             let to_replace = $(htmlData).find('.js_col_ajax_pagination').html();
             $('#js_col_ajax_pagination').html(html_markup);
          }
       });
    });
    $(document).on('click', '.jl-previous-btn-pagination', function (e) {
       e.preventDefault();
       let total_pages = $(this).attr('data-totalpages');
       let current_page = $(this).attr('data-currentpage');
       let next_page = parseInt(current_page) - 1;
       let ajax_url = $(this).attr('data-ajaxurl');
       $.ajax({
          url: ajax_url + "?page=" + next_page + "&view=ajax-collection",
          type: 'GET',
          success: function (htmlData) {
 
             let html_markup = $(htmlData);
             let to_replace = $(htmlData).find('.js_col_ajax_pagination').html();
             $('#js_col_ajax_pagination').html(html_markup);
          }
       });
    });
 });
 
 
 $(document).on('change', '.js_qty', function (e) {
    e.preventDefault();
    let parent = $(e.target).parents('.js_par_qty').eq(0);
    let current_qty = $(this).val();
    let updated_qty = parseInt(current_qty);
    let current_item = {};
    let key = $(parent).attr('data-key');
    current_item[key] = updated_qty;
    $.ajax({
       url: "/cart/update.js",
       data: {
          'updates': current_item
       },
       method: "POST",
       dataType: "JSON",
       success: function (data) {
          $.ajax({
             url: '/cart',
             dataType: 'HTML',
             method: "GET",
             success: function (htmlData) {
                let html_markup = $(htmlData);
                let to_replace = $(htmlData).find('.jl-cart__price-box').html();
                let to_replace_item = $(htmlData).find('.jl-cart__product-added-wrap').html();
                setTimeout(function () {}, 2000);
                $('.jl-cart__price-box').html(to_replace);
                $('.jl-cart__product-added-wrap').html(to_replace_item);
                $.getJSON('/cart.js', function(cart) {
                  let cartCount = cart.item_count;
                  if(cartCount > 1){
                     $(".js_cartcount h1").text(`your cart (${cartCount}  Items)`);
                  }else{
                     $(".js_cartcount h1").text(`your cart (${cartCount}  Item)`);
                  }
               });
               
               saveCartSavePrice();
               youMayAlsoLikeCart();
             }
 
          });
 
 
       },
       error: function (error) {
          console.log(error)
       }
    });
 });

 $(document).on('change', '.js_qty_mobile', function (e) {
   e.preventDefault();
   let parent = $(e.target).parents('.js_par_qty').eq(0);
   let current_qty = $(this).val();
   let updated_qty = parseInt(current_qty);
   let current_item = {};
   let key = $(parent).attr('data-key');
   current_item[key] = updated_qty;
   $.ajax({
      url: "/cart/update.js",
      data: {
         'updates': current_item
      },
      method: "POST",
      dataType: "JSON",
      success: function (data) {
         $.ajax({
            url: '/cart',
            dataType: 'HTML',
            method: "GET",
            success: function (htmlData) {
               let html_markup = $(htmlData);
               let to_replace = $(htmlData).find('.jl-side-cart--cartpage .jl-cart__price-box').html();
               let to_replace_item = $(htmlData).find('.jl-cart__product-added-wrap').html();
               setTimeout(function () {}, 2000);
               $('.jl-cart__price-box').html(to_replace);
               $('.jl-cart__product-added-wrap').html(to_replace_item);
               $.getJSON('/cart.js', function(cart) {
                 let cartCount = cart.item_count;
                 if(cartCount > 1){
                    $(".js_cartcount h1").text(`your cart (${cartCount}  Items)`);
                 }else{
                    $(".js_cartcount h1").text(`your cart (${cartCount}  Item)`);
                 }
              });
              
              saveCartSavePrice();
              youMayAlsoLikeCart();
            }

         });


      },
      error: function (error) {
         console.log(error)
      }
   });
});

 $(document).on('click', '.js-cart-checkout', function (e) {
    let checkutUrl = $(this).attr('data-url');
    window.location = checkutUrl;
 });
 
 
 $(document).on('click', '.jl-blog-listing__filter-wrap a', function (e) {
    $('.jl-blog-listing__filter-wrap a.js_active').removeClass('js_active');
    $(this).addClass('js_active');
 });
 $(document).on('click', '.js_blog', function (e) {
    e.preventDefault();
    $('.jl-blog-listing__pagination-wrap').html('');
    let blogHandle = $(this).attr('data-blog-handle');
    let total_pages = $('#js_blog_box').attr('data-totalpages');
    $.ajax({
       url: '/blogs/' + blogHandle + '?view=jl-ajax-blog',
       async: false,
       type: 'GET',
       success: function (htmlData) {
          // Parse the HTML data
          let html_markup = $(htmlData);
          console.log(html_markup)
          let to_replace = $(html_markup).find('.jl-testt').html();
          let blogTitle = $('.js_active').attr('data-blog-title');
          console.log(blogTitle)
          $('.blog_page_title').text(blogTitle);
          $('.jl-blog-listing__inner-content').html(to_replace);
          let to_pagination = $(htmlData).find('.js_pagination').html();
          $('.jl-blog-listing__pagination-wrap').html(to_pagination);
          $('#js_pagination').show();

          //console.log('Matching Data HTML:', to_pagination);
          // if(total_pages == 1) {
          //     $('#js_pagination').hide(); 
          //     alert(total_pages)
          //   }else{
          //     $('#js_pagination').show(); 
          //   }
       },
       error: function (jqXHR, textStatus, errorThrown) {
          console.error('AJAX Error:', textStatus, errorThrown);
       }
    });
 });
 
 $(document).on('click', '.js-product-quantity-remove', function (e) {
    e.preventDefault();
    let current_em = $(e.target);
    let key = $(this).attr('data-key');
 
    let updated_qty = 0;
    let current_item = {};
    current_item[key] = updated_qty;
    $.ajax({
       url: "/cart/update.js",
       data: {
          'updates': current_item
       },
       method: "POST",
       dataType: "JSON",
       success: function (data) {
          updateCart();
       },
       error: function (error) {
          console.log(error)
       }
    });
 });
 
 
 $(document).on('change', '.js_cart_drawer_qty', function (e) {
    e.preventDefault();
    let parent = $(e.target).parents('.js_par_qty').eq(0);
    let current_qty = $(this).val();
    let updated_qty = parseInt(current_qty);
    let current_item = {};
    let key = $(parent).attr('data-key');
    current_item[key] = updated_qty;
    $.ajax({
       url: "/cart/update.js",
       data: {
          'updates': current_item
       },
       method: "POST",
       dataType: "JSON",
       success: function (data) {
          $.ajax({
             url: '/cart',
             dataType: 'HTML',
             method: "GET",
             success: function (htmlData) {
                updateCart();
             }
          });
 
 
       },
       error: function (error) {
          console.log(error)
       }
    });
 });
 
 $(document).on('click', '.cart-page-remove', function (e) {
    e.preventDefault();
    let current_em = $(e.target);
    let key = $(this).attr('data-key');
 
    let updated_qty = 0;
    let current_item = {};
    current_item[key] = updated_qty;
    $.ajax({
       url: "/cart/update.js",
       data: {
          'updates': current_item
       },
       method: "POST",
       dataType: "JSON",
       success: function (htmlData) {
          $.ajax({
             url: '/cart',
             dataType: 'HTML',
             method: "GET",
             success: function (htmlData) {
                let html_markup = $(htmlData);
                let to_replace = $(htmlData).find('.jl-cart__price-box').html();
                let to_replace_item = $(htmlData).find('#Cart').html();
                setTimeout(function () {}, 2000);
                $('.jl-cart__price-box').html(to_replace);
                $('#Cart').html(to_replace_item);
                saveCartSavePrice();
                youMayAlsoLikeCart();
             }
            
          });
         
       },
       error: function (error) {
          console.log(error)
       }
    });
 });
 
 
 $(document).on('click', '.jl-btn-blog-page-pagination', function (e) {
    e.preventDefault();
    let total_pages = $(this).attr('data-totalpages');
    let current_page = $(this).attr('data-currentpage');
    let next_page = parseInt(current_page);
 
    let blogHandle = $(".js_active").attr("data-blog-handle");
    $.ajax({
       url: "/blogs/" + blogHandle + "?page=" + next_page + "&view=jl-ajax-blog",
       type: 'GET',
       success: function (htmlData) {
 
          let html_markup = $(htmlData);
          let to_replace = $(htmlData).find('.js_blog_box').html();
          console.log("Pagination html " + to_replace)
          $('#js_blog_box').html(html_markup);
          $('#js_pagination').hide();
          redirectToSection("jl_blog_main");
       }
    });
 });
 
 
 $(document).on('click', '.jl-blog-next-btn-pagination', function (e) {
    e.preventDefault();
    let total_pages = $(this).attr('data-totalpages');
    let current_page = $(this).attr('data-currentpage');
    let next_page = parseInt(current_page) + 1;
    let ajax_url = $(this).attr('data-ajaxurl');
    let blogHandle = $(".js_active").attr("data-blog-handle");
    $.ajax({
       url: "/blogs/" + blogHandle + "?page=" + next_page + "&view=jl-ajax-blog",
       type: 'GET',
       success: function (htmlData) {
          let html_markup = $(htmlData);
          let to_replace = $(htmlData).find('.js_blog_box').html();
          console.log("Pagination html " + to_replace)
          $('#js_blog_box').html(html_markup);
          $('#js_pagination').hide();
          redirectToSection("jl_blog_main");
       }
    });
 });
 $(document).on('click', '.jl-blog-previous-btn-pagination', function (e) {
    e.preventDefault();
    let total_pages = $(this).attr('data-totalpages');
    let current_page = $(this).attr('data-currentpage');
    let next_page = parseInt(current_page) - 1;
    let ajax_url = $(this).attr('data-ajaxurl');
    let blogHandle = $(".js_active").attr("data-blog-handle");
    $.ajax({
       url: "/blogs/" + blogHandle + "?page=" + next_page + "&view=jl-ajax-blog",
       type: 'GET',
       success: function (htmlData) {
          let html_markup = $(htmlData);
          let to_replace = $(htmlData).find('.js_blog_box').html();
          console.log("Pagination html " + to_replace)
          $('#js_blog_box').html(html_markup);
          $('#js_pagination').hide();
          redirectToSection("jl_blog_main");
       }
    });
 });

 $( document ).ready(function() {
   recomandationProductLength();
   setTimeout(function(){
      $('.gf-refine-toggle-mobile span').html('<i class="fa fa-tasks" aria-hidden="true"></i> Click Here To Filter Products');
   },1500);
  // $('.afterpay-logo').hide();
   let price = $('.js_after_pay').attr('data-price');
   let dividaedPrice = price / 4;
   $('.js_after_pay').html('$' + dividaedPrice);
   console.log('After pay price ' + dividaedPrice)
   $(document).on('click', '.jl-new-afterpay-logo', function (e) {
   $(".afterpay-modal-overlay").addClass("visible");
   $('afterpay-modal').attr('visible', 'visible');
 });   
  $(document).on(`click`, `.gf-option-block .gf-block-title`, function (e) {
      $('.gf-option-block').addClass('is-collapsed');
      $(this).parrent().removClass('is-collapsed');
  });
  $(document).on("click", ".gf-option-box button", function ()  {
      redirectToSection("gf-grid");
  });

  $(document).on("change", ".jl-sticky-qty", function (e)  {
   e.preventDefault();
  
   let qtyVal = $(this).val();
   $('.jl-main-select').val(qtyVal).trigger('change');
  });
  $(document).on("change", ".jl-main-select", function (e)  {
   e.preventDefault();
   
   let qtyVal = $(this).val();
   $('.jl-sticky-qty').val(qtyVal).trigger('change');
  });
 $(document).on('click','.sticky-product_page_atc',function(e){
   e.preventDefault();
   $('.product_page_atc').trigger('click');
 })

  
  let proPrice = $('.js-price').html();
  let comPrice = $('.js-compare-price').html();
  $('.js_sticky_price').html(proPrice);
  $('.js_sticky_comprice').html(comPrice);
  saveDrawerSavePrice();
  saveCartSavePrice();
});

 
$(document).ready(function(e) {
 
$(document).on("change", ".you-may-also-like__box .variant_select", function(e) {
   let option1 = option2 = option3 = null;
   let parent = $(e.target).closest('.you-may-also-like__box');
   var product_id = parent.find(".variant_select option:selected").val(); 
   if (parent.find('[data-option-1]').length > 0) {
       option1 = parent.find('[data-option-1] option:selected').val();
   
   }
   if (parent.find('[data-option-2]').length > 0) {
      option2 = parent.find('[data-option-2] option:selected').val();
   }
   if (parent.find('[data-option-3]').length > 0) {
      option3 = parent.find('[data-option-3] option:selected').val();
   }
   
   let variant_id = null;
   let current_selected_option = null;
   if (option2 == null & option3 == null) {
      current_selected_option = $(parent.find(`select.actual-variantss option[data-option1='${option1}']`));
      variant_id = $(parent.find(`select.actual-variantss option[data-option1='${option1}']`)).val();
      // alert(variant_id)
   }
   if (option2 != null & option3 == null) {
 
      current_selected_option = $(parent.find(`select.actual-variantss option[data-option1='${option1}'][data-option2='${option2}']`));
      variant_id = $(parent.find(`select.actual-variantss option[data-option1='${option1}'][data-option2='${option2}']`)).val();
   }
   if (option2 != null & option3 != null) {

      current_selected_option = $(parent.find(`select.actual-variantss option[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`));
      variant_id = $(parent.find(`select.actual-variantss option[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`)).val();
   }
   let price =  $(current_selected_option).attr('data-price');
   let comPrice =  $(current_selected_option).attr('data-compareat-price');
   
   let is_available = $(current_selected_option).attr('data-available');
   let savePrice = $(current_selected_option).attr('data-save');
   
   $(parent.find(`.jl_drawer_upsellprice`)).html(price);
   if(savePrice != ''){
      $(parent.find(`.jl-upsell-save`)).html('Save ' + savePrice);
      $(parent.find(`.jl-upsell-badge`)).show();
   }else{
      $(parent.find(`.jl-upsell-badge`)).hide();
   }
   $(parent.find(`.jl_drawer_upsellcomprice`)).html(comPrice);
   $(parent.find(`select.actual-variantss`)).val(variant_id).trigger('change');
   if (is_available == 'true') {
      $(parent.find(`.jl-drawer-upsell`)).text('add to cart');
      $(parent.find(`.jl-drawer-upsell`)).css('pointer-events', 'all');
      $(parent.find(`.jl-drawer-upsell`)).css('opacity', '1');
   } else {
      $(parent.find(`.jl-drawer-upsell`)).text('sold out'); 
      $(parent.find(`.jl-drawer-upsell`)).css('pointer-events', 'none');
      $(parent.find(`.jl-drawer-upsell`)).css('opacity', '0.5');
   }
});

 $(document).on('click', '.you-may-also-like__box .jl-drawer-upsell', function (e) {
    e.preventDefault();
    let parent = $(e.target).closest('.you-may-also-like__box');
    let varId = parent.find("select.actual-variantss option:selected").val(); 
   
    $.ajax({
       url: "/cart/add.js",
       data: {
          id: varId,
          quantity: 1
       },
       method: "POST",
       dataType: "JSON",
       success: function (data) {
          
           setTimeout(function () {}, 2000);
         //   $('.jl-side-cart').addClass('open');
         //   $('body').addClass('scroll-hidden');
         updateCart();
       },
       error: function (data) {
          window.alert(data.responseJSON.description);
       }
    });
 });
 $(document).on('click', '.you-may-also-like__box .jl-cart-upsell', function (e) {
   e.preventDefault();
   let parent = $(e.target).closest('.you-may-also-like__box');
   let varId = parent.find("select.actual-variantss option:selected").val(); 
  
   $.ajax({
      url: "/cart/add.js",
      data: {
         id: varId,
         quantity: 1
      },
      method: "POST",
      dataType: "JSON",
      success: function (htmlData) {
         $.ajax({
            url: '/cart',
            dataType: 'HTML',
            method: "GET",
            success: function (htmlData) {
               
               let html_markup = $(htmlData);
               let to_replace = $(htmlData).find('.jl-cart__price-box').html();
               let to_replace_item = $(htmlData).find('#Cart').html();
               setTimeout(function () {}, 2000);
               $('.jl-cart__price-box').html(to_replace);
               $('#Cart').html(to_replace_item);
               saveCartSavePrice();
               youMayAlsoLikeCart();
            }
         });
      },
      error: function (data) {
         window.alert(data.responseJSON.description);
      }
   });
});
 
$('.variant_select').trigger('change');

});
       